export default __webpack_public_path__ + "static/media/Angileri.e2d6da15.jpg";